<template>
  <div class="grid-responsive">
    <div class="grid">
      <div v-for="(item, i) in items" :key="item.id"
        class="grid-item"
        :style="{ 
          backgroundColor: (currentIndex === i && highlight) 
                            ? '#b4ded5' 
                            : $store.getters.printStaffColor(item) 
        }"
        @click="handleClickItem(item, i)">
        {{ type == 'staff' ? $store.getters.printStaffName(item.id) : item.name }}<br>
        <template v-if="type == 'staff'">{{ item.ref }}</template>
      </div>
      <div class="text-result" v-if="!items.length" v-translate>No results found!</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GridView',
  props: {
    items: { type: Array, default: () => ([]) },
    highlight: { type: Boolean, default: false },
    type: { type: String, default: '' },
  },
  data() {
    return {
      currentIndex: null,
    };
  },
  methods: {
    handleClickItem(item, index) {
      this.currentIndex = index;
      this.$emit('pickItem', item);
    }
  },
};
</script>
